module.exports = __webpack_public_path__ + "img/man-in-truck.ce6a597a.png";